(function () {
  var SECTION_SELECTOR = '[data-related-products]';

  /* Fisher-Yates. Returns a new array; leaves the input alone. */
  function shuffled(list) {
    var out = list.slice();
    for (var i = out.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = out[i];
      out[i] = out[j];
      out[j] = tmp;
    }
    return out;
  }

  /* "Blankets=2|Puzzles=1|Art Prints=1|" -> [{type:'blankets', count:2}, ...]
     Types are lower-cased here and compared lower-cased, so a merchant
     typing "blankets" still matches a product typed "Blankets". */
  function parseQuotas(raw) {
    var out = [];
    if (!raw) return out;
    raw.split('|').forEach(function (pair) {
      if (!pair) return;
      var at = pair.lastIndexOf('=');
      if (at < 1) return;
      var type = pair.slice(0, at).trim().toLowerCase();
      var count = parseInt(pair.slice(at + 1), 10);
      if (type && count > 0) out.push({ type: type, count: count });
    });
    return out;
  }

  /* Picks the row from the rendered pool: each quota's share first (chosen at
     random from that type), then a random backfill from whatever is left so
     the row always reaches `total` cards even if the store is short on a type.

     Returns the winning elements in a shuffled order, so the types aren't
     always laid out in quota order (2 blankets, then puzzle, then art print). */
  function pickRow(pool, quotas, total) {
    var byType = {};
    pool.forEach(function (el) {
      var card = el.querySelector('[data-product-type]');
      var type = (card ? card.getAttribute('data-product-type') : '') || '';
      type = type.trim().toLowerCase();
      (byType[type] = byType[type] || []).push(el);
    });

    var chosen = [];
    var taken = new Set();

    quotas.forEach(function (quota) {
      var candidates = shuffled(byType[quota.type] || []);
      var filled = 0;
      for (var i = 0; i < candidates.length && filled < quota.count; i++) {
        var el = candidates[i];
        if (taken.has(el)) continue;
        chosen.push(el);
        taken.add(el);
        filled++;
      }
    });

    /* Backfill — any type, random, never past the total. */
    if (chosen.length < total) {
      var leftovers = shuffled(pool.filter(function (el) { return !taken.has(el); }));
      for (var k = 0; k < leftovers.length && chosen.length < total; k++) {
        chosen.push(leftovers[k]);
        taken.add(leftovers[k]);
      }
    }

    /* A quota mix summing to more than the total would otherwise overflow
       the 4-column grid onto a second row. */
    return shuffled(chosen).slice(0, total);
  }

  function buildRow(root) {
    var track = root.querySelector('[data-related-track]');
    if (!track) return;

    var pool = Array.prototype.slice.call(track.querySelectorAll('[data-related-pool]'));
    if (!pool.length) {
      track.classList.remove('invisible');
      return;
    }

    var total = parseInt(root.getAttribute('data-related-total'), 10) || 4;
    var quotas = parseQuotas(root.getAttribute('data-related-quotas'));
    var winners = pickRow(pool, quotas, total);

    /* Losers are removed rather than hidden: on desktop the wrapper is
       lg:contents, so a hidden wrapper would still leak its card into the
       grid. Removal also drops their lazy images from the load. */
    pool.forEach(function (el) {
      if (winners.indexOf(el) === -1) {
        el.remove();
      } else {
        el.removeAttribute('data-related-pool');
        el.setAttribute('data-related-item', '');
      }
    });

    /* Re-append in the picked order — pickRow shuffled them, but the DOM
       still holds the original catalogue order. */
    winners.forEach(function (el) { track.appendChild(el); });

    track.classList.remove('invisible');
  }

  /* Mobile-only carousel (desktop keeps the static grid and hides the
     arrows via lg:hidden). Scrolls by one card's width per click using
     native scrollBy — the track itself is a real scroll container
     (scroll-snap), so touch swipe works for free alongside the arrows. */
  function init(root) {
    if (!root || root.dataset.relatedInit === 'true') return;
    root.dataset.relatedInit = 'true';

    buildRow(root);

    var controller = new AbortController();
    root.relatedController = controller;
    var signal = { signal: controller.signal };

    var track = root.querySelector('[data-related-track]');
    var prev = root.querySelector('[data-related-prev]');
    var next = root.querySelector('[data-related-next]');
    if (!track || !prev || !next) return;

    function scrollByCard(direction) {
      var card = track.querySelector('[data-related-item]');
      var amount = card && card.offsetWidth ? card.offsetWidth : track.clientWidth;
      track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { scrollByCard(-1); }, signal);
    next.addEventListener('click', function () { scrollByCard(1); }, signal);
  }

  function teardown(root) {
    if (!root) return;
    if (root.relatedController) {
      root.relatedController.abort();
      delete root.relatedController;
    }
    root.removeAttribute('data-related-init');
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(init);

  if (!window.__relatedProductsWired) {
    window.__relatedProductsWired = true;
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector(SECTION_SELECTOR);
      if (root) init(root);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector(SECTION_SELECTOR);
      if (root) teardown(root);
    });
  }
})();
